import classNames from 'classnames';
import {
  formatPrice,
} from '@dinosave/core';
import type {
  ItemEntity,
} from '@dinosave/core/types';
import ItemPrice from '@/components/Items/ItemPrice';
import Text from '@/ui/components/Text';
import {
  ArrowUpRightIcon,
} from '@/ui/icons';

import styles from './ItemStatic.module.css';

type ItemStaticEntity = {
  name: string;
  url: string;
  currency: string;
  currentPrice: number;
  previousPrice?: number;
  image: string;
  user: string;
}

type ItemStaticProps = {
  item: ItemStaticEntity;
  className?: string;
}
const ItemStatic = (props: ItemStaticProps) => {
  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    item,
    className,
    ...rest
  } = props;

  const {
    url = '',
    name = '',
    image,
  } = item || {};

  const imageUrl = image as string;

  // ##########################################################################
  // CONSTANTS
  // ##########################################################################

  const hostname = url ? new URL(url).hostname.replace(/^www\./, '') : '';

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const itemClassName = classNames({
    [styles.itemStatic]: true,
    [styles.grid]: true,
    [className]: !!className,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div
      {...rest}
      className={itemClassName}
    >
      <div className={styles.user}>
        <img src={item.user} />
      </div>

      <div className={styles.media}>
        <img
          key="mediaImage"
          src={imageUrl}
          alt={item?.name}
          className={styles.mediaImage}
          crossOrigin="anonymous"
        />
      </div>

      <div className={styles.details}>
        <Text
          color="neutral-500"
          weight="500"
          className={styles.link}
        >
          {hostname}
        </Text>

        <Text
          weight="600"
          className={styles.name}
        >
          {name}
        </Text>

        <div className={styles.price}>
          <Text
            kind="control"
            size="regular"
            weight="600"
            className={styles.priceText}
          >
            {formatPrice(item.currentPrice, item.currency)}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default ItemStatic;
